import React from "react";

const CarrinhoContext = React.createContext();

export default CarrinhoContext;
